import { _axios } from '../../plugins/axios'
import store from '../../store'
import MetricsController from './MetricsController'

class AvgCompletedPtEvals extends MetricsController {
  value = {
    labels: [],
    datasets: [
      {
        label: 'Avg. Completed PT Evals',
        data: []
      }
    ]
  }

  getData () {
    const queryString = this.formatQueryParams()
    return _axios.get(`${store.getters['Organization/apiUrl']}/metrics/avgCompletedPtEvals${queryString}`)
      .then((response) => {
        this.processTimeSeriesResponse(response)

        return this.value
      })
  }
}

export default new AvgCompletedPtEvals()
